/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var webOrderID;
  var numberList;

  var createQR = function createQR(data) {
    var htmlText = '';
    var data = JSON.parse(data);
    console.log(data);

    if (data.ALERT != undefined && data.ALERT != "") {
      $f7.dialog.alert(data.ALERT);
    }

    if (data.status == "1") {
      new QRCode(document.getElementById("qrcodebook"), data.orderId);
      webOrderID = data.orderId;
      htmlText = "\n      <div class=\"block\">\n        \n        <table width=100%>\n          <tbody>\n          <tr>\n              <td colspan=2><hr/></td>\n          </tr>  \n      ";
      htmlText += "<tr><td colspan=2 style='font-size:16px;'><div style='background-color:#D6DBDF'></div><table width=100%>";

      for (var j = 0; j < data.details.length; j++) {
        var amountType = "";

        for (var k = 0; k < data.details[j].amount.length; k++) {
          var numberType = data.details[j].amount[k].type;
          var numberValue = data.details[j].amount[k].value;

          if (numberValue == "0.00") {
            numberType = "-";
            numberValue = "----";
          }

          amountType += "<td style='font-size:16px;text-align:right'>" + numberType + "-" + numberValue + "</td>";
        }

        htmlText += "  \n            <tr>\n              <td style='font-size:16px'>" + data.details[j].type + "<span style='font-size:20px'><b> " + data.details[j].number + "</b></span></td>\n              <td style='font-size:12px'>" + data.details[j].position + "</td> \n              " + amountType + "\n            </tr>   \n          ";
      }

      htmlText += "</table></td></tr>";
      var myphone = localStorage.getItem("myphone");
      if (myphone == "skip") myphone = "";
      htmlText += "\n          <tr>\n              <td style=\"text-align:left; font-size:20px;\">\n              <span class=\"myphone\">" + myphone + "</span>\n              </td>\n              <td style=\"text-align:right; font-size:20px;\"><b>TOTAL: $" + data.total + "</b></td>\n          </tr> \n        ";
      var color1 = "";
      if (data.GDP == "--------") color1 = "style='color:red'";
      htmlText += "\n            <tr><td colspan=2 " + color1 + ">GDP:" + data.GDP + "</td></tr> \n            <tr><td colspan=2 " + color1 + ">" + data.gd4dJP + "</td></tr>\n            <tr><td colspan=2 " + color1 + ">" + data.gd6dJP + "</td></tr>\n            </tbody>\n          </table>\n        </div>\n        ";
      $('.printtext').html(htmlText);
      $update();
    } else {
      var errorMsg = data.errmsg;
      if (errorMsg == "ERR_INVALID_NUMBER") errorMsg = "Please fill in four number";
      if (errorMsg == "ERR_INVALID_AMOUNT") errorMsg = "Please fill in amount";
      $f7.dialog.alert(errorMsg);
    }
  };

  $on('pageInit', function () {
    if (window.origin == "history") {
      createQR(window.web_data);
      return;
    }

    $f7.request({
      method: 'get',
      url: window.waypoint + 'book.aspx',
      data: {
        reqId: window.uuid,
        bet: window.book,
        form: window.form,
        smsnum: localStorage.getItem("myphone")
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        createQR(data);

        for (var i = 20; i > 0; i--) {
          localStorage.setItem("web" + i, localStorage.getItem("web" + (i - 1)));
        }

        localStorage.setItem("web0", data);
      }
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about" >
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Book QR</div>
    </div>
  </div>
  
  <div class="page-content" style="background-color: white; color:black;" >

    <br/><br/><br/> 
    <center>
    
      
    <div style="background-image: url('static/images/white.jpg'); background-repeat: repeat;background-size: cover;background-color: white; padding: 20px; width: 250px;">
      <div id="qrcodebook"></div>
    </div>  
    <p>
      ORDER ID<br/>
      ${webOrderID}

      <br/><br/>
      Here is your booking number
    </p>
    
    </center>
    <div class="printtext">

    </div>


  </div>
</div>
`
    }
    ;
}

framework7Component.id = '86d8c415f9';
export default framework7Component;